<template>
  <div class="password-reset">
    <app-title title="Wachtwoord reset"/>

    <div class="row">
      <div class="col-md-3 p-md-3 text-center">
        <img class="header-logo" src="/images/logo.png">
      </div>
      <div class="col-md-7 content-middle dashboard-row p-md-3 mt-md-3">
        <router-link class="link" to="/dashboard">
          <font-awesome-icon class="font-awesome-icon" icon="arrow-circle-left"/>
          Dashboard
        </router-link>
      </div>
      <div class="col-md-3 p-md-3 d-none d-sm-block"></div>
    </div>

    <div class="row">
      <div class="col-md-3 d-none d-sm-block"></div>
      <div class="col-md-7 content-middle main p-md-3">
        <div class="title">
          Wachtwoord reset
        </div>
      </div>
      <div class="col-md-3 d-none d-sm-block"></div>
    </div>

    <div class="row">
      <div class="col-md-3 p-md-3 d-none d-sm-block"></div>
      <div class="col-md-7 content-middle p-md-3">
        <app-reset-password :token="token" :email="email"/>
      </div>
      <div class="col-md-3 p-md-3 d-none d-sm-block"></div>
    </div>
  </div>
</template>

<script>
  import ResetPassword from '../components/Auth/ResetPassword'

  export default {
    name: 'password-reset',
    props: ['token', 'email'],
    components: {
      'app-reset-password': ResetPassword
    }
  }
</script>
